<template>
  <layout>
    <page-header :header="$t('general.edit')" />
    <div class="content">
      <RuleForm
        :id="$route.params.id"
        :api-interface="api"
        @saved="returnBack"
        @cancel="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import RuleForm from './Form.vue'
import PeriodPricingApi from './Api'

const base = 'period_pricing'

export default {
  name: 'PeriodPricingEdit',

  components: {
    RuleForm,
  },

  computed: {
    ...mapState('zones', ['currentDivision']),
    api() {
      const params = {}
      if (this.currentDivision?.id) {
        params.division_id = this.currentDivision.id
      }
      return new PeriodPricingApi(params)
    },
  },

  methods: {
    returnBack() {
      this.$router.push({ name: base })
    },
  },
}
</script>
